import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

import { useClientStore } from 'apps/hooks';

import CustomerRFQPage from 'apps/rfq/rfqPage/views/customerView';
import IntermediatorRFQPage from 'apps/rfq/rfqPage/views/intermediatorView';
import ManufacturerRFQPage from 'apps/rfq/rfqPage/views/manufacturerView';

const OpenRFQ = observer(props => {
  const { rfqManager } = props;
  const clientStore = useClientStore();
  const isIntermediator = clientStore.currentPortal === 'INTERMEDIATOR';
  const isManufacturer = clientStore.currentPortal === 'MANUFACTURER';

  let RFQView = CustomerRFQPage;
  if (isIntermediator) {
    RFQView = IntermediatorRFQPage;
  } else if (isManufacturer) {
    RFQView = ManufacturerRFQPage;
  }

  return <RFQView rfqManager={rfqManager} />;
});

OpenRFQ.propTypes = {
  rfqManager: PropTypes.object,
};

export default withNamespaces()(OpenRFQ);
